import React from 'react';
import { FN111A } from '../../../services/pwn201Api';

interface Props {
  rows: FN111A[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FN111A, value: unknown) => void;
}

const TabOffsetDetails: React.FC<Props> = React.memo(({ rows, isEditing, onAdd, onDelete, onChange }) => (
  <div className="pwn201-tab-content">
    {isEditing && (
      <div className="pwn201-tab-toolbar">
        <button onClick={onAdd} className="btn-add">+ 新增抵帳交運單</button>
      </div>
    )}
    <table className="pwn201-grid">
      <thead>
        <tr>
          <th>序號</th>
          <th>交運單號</th>
          <th>抵帳金額</th>
          <th>應收餘額</th>
          {isEditing && <th>操作</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.fn111a_02}</td>
            <td>
              <input
                value={row.fn111a_11}
                onChange={(e) => onChange(idx, 'fn111a_11', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                type="number"
                value={row.fn111a_12}
                onChange={(e) => onChange(idx, 'fn111a_12', parseFloat(e.target.value) || 0)}
                disabled={!isEditing}
              />
            </td>
            <td>{row.fn111a_12a.toLocaleString()}</td>
            {isEditing && (
              <td>
                <button onClick={() => onDelete(idx)} className="btn-delete">刪除</button>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={isEditing ? 5 : 4} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
        )}
      </tbody>
    </table>
  </div>
));

export default TabOffsetDetails;
